var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "newIccStyles" },
    [
      _vm.hasError
        ? _c("div", { staticClass: "error--text" }, [
            _vm._v(
              "\n        There is an error while fetching data from the query.\n        Please try again later.\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.contentSections.length && _vm.xmlIds.length && !_vm.isLoading
        ? _c("div", [
            _c("p", [
              _vm._v("No content found for query "),
              _c("b", [_vm._v('"' + _vm._s(_vm.xmlIds) + '"')]),
            ]),
          ])
        : _c(
            "div",
            _vm._l(_vm.contentSections, function (contentSection) {
              return _c("content-section", {
                key: contentSection.sectionId,
                attrs: {
                  contentSection: contentSection,
                  contentModifiers: _vm.createContentModifiers(),
                },
                on: { "breadcrumb-clicked": _vm.handleBreadcrumbClick },
              })
            }),
            1
          ),
      _vm._v(" "),
      _c("peak-ahead"),
      _vm._v(" "),
      _c("astm-modal"),
      _vm._v(" "),
      _c("bookmark-modal"),
      _vm._v(" "),
      _c("notes-modal"),
      _vm._v(" "),
      _c("premium-tools-access-restriction-modal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }